import { inject, Injectable } from '@angular/core';
import { Product } from '@df/catalog/product/product';
import { Resource } from '@df/catalog/resource';
import { StockResource } from '../stock/stock.resource';

declare module '@df/catalog/resource' {
    interface IResources {
        product: Resource<Product, number>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProductResource extends Resource<Product, number> {
    static override instance = Product;
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = false;
    private stockResource = inject(StockResource);
}
